import React from 'react';
import { HomeViewV2 } from 'views/rebranded-module/HomeViewV2';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import { HydrationWrapper } from 'views/common/components';
import { useSelector } from 'react-redux';
import { checkIfUrlHasCorrectSegmentsTranslations } from 'lib/utils/checkIfUrlHasCorrectSegmentsTranslations';
import handleHomeSSR from 'views/HomeView/utils/handleHomeSSR';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';

const Home = (props) => {
  const {
    serverData, initWidgetData, renderErrorPage, cmsData,
  } = props;

  const { isCrawler } = useSelector((state) => state.globalData);
  const handleErrorResponse = useErrorsHandler();
  if (renderErrorPage) {
    handleErrorResponse({}, false);
  }

  if (isCrawler) {
    return (
      <HydrationWrapper>
        <ContentContext.Provider value={cmsData}>
          <HomeViewV2 serverData={serverData} initWidgetData={initWidgetData} />
        </ContentContext.Provider>
      </HydrationWrapper>
    );
  }
  return (
    <ContentContext.Provider value={cmsData}>
      <HomeViewV2 serverData={serverData} initWidgetData={initWidgetData} />
    </ContentContext.Provider>
  );
};
export async function getServerSideProps(ctx) {
  const homeSSR = await handleHomeSSR(ctx);
  const isCorrectSegemntTranslation = checkIfUrlHasCorrectSegmentsTranslations(
    ctx,
    homeSSR.props.hreflangData.canonical,
  );
  if (isCorrectSegemntTranslation.shouldRedirect) {
    return {
      redirect: {
        destination: isCorrectSegemntTranslation.redirectURL,
        permanent: true,
      },
    };
  }
  return homeSSR;
}
export default Home;
